import { render, staticRenderFns } from "./ProductViewID.vue?vue&type=template&id=24c23e0d&scoped=true&"
import script from "./ProductViewID.vue?vue&type=script&lang=js&"
export * from "./ProductViewID.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c23e0d",
  null
  
)

export default component.exports